<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Tax Relief Contribution Rate"
      text="Edit Tax Relief Contribution Rate"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="localTaxRelief.name"
              label="Name"
              disabled
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localTaxRelief.amount"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('amount')"
              data-vv-name="amount"                
              data-vv-as="amount"  
              prefix="RM"          
              label="Amount"
            />
          </v-col>
        </v-row> 
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    props: {
      taxRelief: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localTaxRelief: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localTaxRelief = { ...this.taxRelief }
        this.localTaxRelief.amount = (this.localTaxRelief.amount / 100).toFixed(2)
      },
    },
    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.taxRelief().update(this.localTaxRelief.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
                this.dialog = false 
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          amount: this.localTaxRelief.amount * 100,
        }
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>
